import { all, call, put, takeLatest } from 'redux-saga/effects';

import { request } from '@app/services';
import * as actions from './slice';
import * as endpoints from './endpoints';

function* getAllTaskEtaSaga(action: ReturnType<typeof actions.getAllTaskEta>): any {
  try {
    const { projectId } = action.payload;
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    const result = yield call(request.get, `${endpoints.getAllTaskEta}${projectId}`);
    yield put(actions.getAllTaskEtaSuccess(result.data));
  } catch (err) {
    yield put(actions.getAllTaskEtaFailed(err));
  }
}

function* etaSagas() {
  yield all([takeLatest(actions.getAllTaskEta, getAllTaskEtaSaga)]);
}

export { etaSagas };
